import { useSearchParams } from "react-router-dom";
import type { TaxonomyMode } from "@/api/submissions.service";
import { parseTaxonomyMode } from "@/utils/taxonomyFilter";
import { useFeatureFlags } from "./useFeatureFlags";

export const NEW_TAXONOMY_FLAG = "new-taxonomy";
export const TAXONOMY_URL_PARAM = "taxonomy";

export function useTaxonomyMode(fallback?: string) {
  const { hasFlag, isLoading } = useFeatureFlags();
  const [searchParams] = useSearchParams();
  const toggleVisible = hasFlag(NEW_TAXONOMY_FLAG);
  const mode: TaxonomyMode = toggleVisible
    ? parseTaxonomyMode(searchParams.get(TAXONOMY_URL_PARAM) ?? fallback)
    : "legacy";
  return { toggleVisible, mode, taxonomy: toggleVisible ? mode : undefined, ready: !isLoading };
}
